import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, watch } from "vue";

/**
 * Types
 */
type RangeValue = string | undefined;

type Range = RangeValue[];
/**
 * Utils
 */


export default /*#__PURE__*/_defineComponent({
  __name: 'DropdownRangeInput',
  props: {
    value: null,
    rangeUnit: null,
    labelString: null,
    minValueLabelString: null,
    maxValueLabelString: null
  },
  emits: ["input"],
  setup(__props: any, { emit }: { emit: ({
  (e: "input", value: Range): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  value: Range;
  rangeUnit: string;
  labelString: string;
  minValueLabelString: string;
  maxValueLabelString: string;
};

const isValueNumber = (value: string | undefined) => {
  if (value) {
    if (Number(value) === 0) {
      return true;
    }

    if (!Number(value)) {
      return false;
    }
  }

  return true;
};

/**
 * Components
 */





const isDropdownOpen = ref(false);
const minimumValue = ref<string>();
const maximumValue = ref<string>();

const valueLabel = computed(() => {
  const minValue = props.value[0];
  const maxValue = props.value[1];

  if (!isDropdownOpen.value) {
    if (!!minValue && !!maxValue && Number(minValue) < Number(maxValue)) {
      return `${minValue} - ${maxValue} ${props.rangeUnit}`;
    }
  }

  return props.labelString;
});

const isMinimumValueNumber = computed(() => {
  return isValueNumber(props.value[0]);
});

const isMaximumValueNumber = computed(() => {
  return isValueNumber(props.value[1]);
});

const range = computed(() => {
  return [minimumValue.value, maximumValue.value];
});

const rangeValue = computed(() => props.value);

const hideDropdown = () => {
  isDropdownOpen.value = false;
};

watch(range, (newValue) => {
  emit("input", newValue);
});

watch(rangeValue, (newValue) => {
  if (!newValue.length) {
    minimumValue.value = undefined;
    maximumValue.value = undefined;
  }
});

return { __sfc: true,isValueNumber, emit, props, isDropdownOpen, minimumValue, maximumValue, valueLabel, isMinimumValueNumber, isMaximumValueNumber, range, rangeValue, hideDropdown }
}

})